import { render } from "./Home.vue?vue&type=template&id=0530bf89&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "@/assets/css/Header.css?vue&type=style&index=0&id=0530bf89&scoped=true&lang=css&external"
import "@/assets/css/Footer.css?vue&type=style&index=1&id=0530bf89&scoped=true&lang=css&external"
import "./Home.vue?vue&type=style&index=2&id=0530bf89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0530bf89"]])

export default __exports__